const Dictionary = {
  bookingAmendFormLoginSigOutTitle: {
    key: 'bookingAmendFormLoginSigOutTitle',
    defaultValue: 'Sign in to make a payment, add guests info, and more',
  },
  bookingAmendFormLoginSigInCta: {
    key: 'bookingAmendFormLoginSigInCta',
    defaultValue: 'Sign in',
  },
  bookingAmendFormLoginLogedTitle: {
    key: 'bookingAmendFormLoginLogedTitle',
    defaultValue: 'Manage my reservation',
  },
  bookingAmendFormLoginUnLoggedDescription: {
    key: 'bookingAmendFormLoginUnLoggedDescription',
    defaultValue: 'Or look up your reservation using your cruise information',
  },
  bookingAmendNotificationNewGuestAccountTitle: {
    key: 'bookingAmendNotificationNewGuestAccountTitle',
    defaultValue: 'Your account was successfully created!',
  },
  bookingAmendNotificationNewGuestAccountMessage: {
    key: 'bookingAmendNotificationNewGuestAccountMessage',
    defaultValue: 'Use your account to manage your payments, and modify upcoming cruises.',
  },
  bookingAmendChAirMessage: {
    key: 'bookingAmendChAirMessage',
    defaultValue: 'To purchase flights, first make sure your minimum deposit has been paid.',
  },
  bookingAmendLookUpSubtitleNoBookings: {
    key: 'bookingAmendLookUpSubtitleNoBookings',
    defaultValue: 'No bookings are associated with your account.',
  },
  bookingAmendLookUpDescriptionNoBookings: {
    key: 'bookingAmendLookUpDescriptionNoBookings',
    defaultValue:
      'New accounts my take a few minutes to link bookings. Use the form below to look up your reservation or try again later.',
  },
  formBookingAmendSectionDescription: {
    key: 'formBookingAmendSectionDescription',
    defaultValue: 'Please enter your cruise information to ',
  },
  formBookingAmendSectionDescriptionSecond: {
    key: 'formBookingAmendSectionDescriptionSecond',
    defaultValue: ' view and edit your reservation details.',
  },
  formBookingAmendSectionDescriptionThird: {
    key: 'formBookingAmendSectionDescriptionThird',
    defaultValue:
      ' You can only make payments online if you have booked directly with Royal Caribbean.',
  },
  amendFlightsExpandedChangeFlightsCTA: {
    key: 'amendFlightsExpandedChangeFlightsCTA',
    defaultValue: 'Change Flights',
  },
  flightsExpandedNotEligible: {
    key: 'flightsExpandedNotEligible',
    defaultValue: 'This flight is not eligible for cancellation.',
  },
  flightsExpandedProceedWithCancellation: {
    key: 'flightsExpandedProceedWithCancellation',
    defaultValue: 'For assistance please call ',
  },
  flightsExpandedProceedWithCancellationAt: {
    key: 'flightsExpandedProceedWithCancellationAt',
    defaultValue: 'at  ',
  },
  viewCancellationModalTitle: {
    key: 'viewCancellationModalTitle',
    defaultValue: 'Flight change/cancellation fees',
  },
  viewCancellationModalDescription: {
    key: 'viewCancellationModalDescription',
    defaultValue:
      'Changing or cancelling flight reservations may result in additional fees based on the fare type. Please check the fare type of the flights on this reservation and review the schedule below for detailed change and cancellation fees.',
  },
  viewCancellationModalTableTitle: {
    key: 'viewCancellationModalTableTitle',
    defaultValue: 'Date of change/cancellation',
  },
  viewCancellationModalTodayLabel: {
    key: 'viewCancellationModalTodayLabel',
    defaultValue: 'Today through',
  },
  viewCancellationModalOnwardsLabel: {
    key: 'viewCancellationModalOnwardsLabel',
    defaultValue: 'and onwards',
  },
  viewCancellationModalFeesLabel: {
    key: 'viewCancellationModalFeesLabel',
    defaultValue: 'Fee per person',
  },
  viewCancellationFeeesCta: {
    key: 'viewCancellationFeeesCta',
    defaultValue: 'View cancellation fees',
  },
  amendFlightsCancellationFeesModal: {
    key: 'amendFlightsCancellationFeesModal',
    defaultValue: 'Close modal',
  },
  amendFlightTypeOneWay: {
    key: 'amendFlightTypeOneWay',
    defaultValue: 'One way',
  },
  amendFlightTypeRoundtrip: {
    key: 'amendFlightTypeRoundtrip',
    defaultValue: 'Roundtrip',
  },
  amendFlightTypeMultiCity: {
    key: 'amendFlightTypeMultiCity',
    defaultValue: 'Multi-city',
  },
  amendPaymendDetailsBalanceDueDateLabel: {
    key: 'amendPaymendDetailsBalanceDueDateLabel',
    defaultValue: 'Balance due date',
  },
  amendPaymendDetailsBalanceDepositDateLabel: {
    key: 'amendPaymendDetailsBalanceDepositDateLabel',
    defaultValue: 'Deposit due date',
  },
  amendPaymendDetailsMessageAdviceComplete: {
    key: 'amendPaymendDetailsMessageAdviceComplete',
    defaultValue: '*To avoid cancellation of this reservation, complete payment by',
  },
  amendPaymendDetailsMessageAdvicePay: {
    key: 'amendPaymendDetailsMessageAdvicePay',
    defaultValue: '*To avoid cancellation of this reservation, pay minimum deposit by',
  },
  amendPaymentHistoryTitle: {
    key: 'amendPaymentHistoryTitle',
    defaultValue: 'Payment history',
  },
  paymentBookingAmendPaymentDate: {
    key: 'paymentBookingAmendPaymentDate',
    defaultValue: 'Date',
  },
  paymentBookingAmendAmount: {
    key: 'paymentBookingAmendAmount',
    defaultValue: 'Amount',
  },
  paymentBookingAmendPaymentType: {
    key: 'paymentBookingAmendPaymentType',
    defaultValue: 'Payment type',
  },
  paymentBookingAmendType: {
    key: 'paymentBookingAmendType',
    defaultValue: 'Type',
  },
  amendPaidSuccessfully: {
    key: 'amendPaidSuccessfully',
    defaultValue: 'Paid successfully',
  },
  amendPaymentStatus: {
    key: 'amendPaymentStatus',
    defaultValue: 'Payment status',
  },
  amendPaymentCompleted: {
    key: 'amendPaymentCompleted',
    defaultValue: 'Completed',
  },
  amendPaymentTotalBalancePaid: {
    key: 'amendPaymentTotalBalancePaid',
    defaultValue: 'Total balance paid',
  },
  amendPaymentTableHeaderStatus: {
    key: 'amendPaymentTableHeaderStatus',
    defaultValue: 'Status',
  },
  amendPaymentTableRowPaid: {
    key: 'amendPaymentTableRowPaid',
    defaultValue: 'Paid',
  },
  amendPaymentScheduleDateTitle: {
    key: 'amendPaymentScheduleDateTitle',
    defaultValue: 'Schedule date',
  },
  amendPaymentSchedulePaymentAmount: {
    key: 'amendPaymentSchedulePaymentAmount',
    defaultValue: 'Payment amount',
  },
  amendPaymentSPCtaButton: {
    key: 'amendPaymentSPCtaButton',
    defaultValue: 'Manage payments',
  },
  countdownBookingAmendCourtesyHold: {
    key: 'countdownBookingAmendCourtesyHold',
    defaultValue: 'Expires in',
  },
  countdownBookingAmendSetSail: {
    key: 'countdownBookingAmendSetSail',
    defaultValue: 'Sails in',
  },
  itineraryBookingAmendNights: {
    key: 'itineraryBookingAmendNights',
    defaultValue: 'Nights',
  },
  itineraryBookingAmenNight: {
    key: 'itineraryBookingAmenNight',
    defaultValue: 'Night',
  },
  itineraryBookingAmendDays: {
    key: 'itineraryBookingAmendDays',
    defaultValue: 'Days',
  },
  itineraryBookingAmendDay: {
    key: 'itineraryBookingAmendDay',
    defaultValue: 'Day',
  },
  heroTitleCompletePayment: {
    key: 'heroTitleCompletePayment',
    defaultValue: 'Pay deposit to book your cruise',
  }, // AEM update
  heroTitlePayYourBooking: {
    key: 'heroTitlePayYourBooking',
    defaultValue: 'Make a payment towards your remaining balance due',
  }, // AEM update
  heroTitlePlanYourActivities: {
    key: 'heroTitlePlanYourActivities',
    defaultValue: 'Start planning your adventure. Shop excursions, drink packages and more.',
  }, // AEM update
  amendHeroCourtesyHoldLabel: {
    key: 'amendHeroCourtesyHoldLabel',
    defaultValue: 'Courtesy Hold',
  },
  amendHeroActionsTitle: {
    key: 'amendHeroActionsTitle',
    defaultValue: 'Up next',
  },
  heroSubtitleScheduledPayments: {
    key: 'heroSubtitleScheduledPayments',
    defaultValue: 'A payment of',
  },
  heroSubtitleScheduledPaymentsLabel: {
    key: 'heroSubtitleScheduledPaymentsLabel',
    defaultValue: 'will be processed on ',
  },
  heroSubtitleBrazilCourtesyHold: {
    key: 'heroSubtitleBrazilCourtesyHold',
    defaultValue: 'Call to make a payment ',
  },
  amendBrazilCallCenterNumber: {
    key: 'amendBrazilCallCenterNumber',
    defaultValue: '0800-8913994',
  },
  heroBookingAmendTaCourtesyHoldDescription: {
    key: 'heroBookingAmendTaCourtesyHoldDescription',
    defaultValue: 'Contact your travel advisor to make a payment',
  },
  amendCardFlightSubtitle: {
    key: 'amendCardFlightSubtitle',
    defaultValue: 'Book with royal caribbean',
  },
  amendCheckboxLabelFooterPayment: {
    key: 'amendCheckboxLabelFooterPayment',
    defaultValue: 'Agree to the ',
  },
  amendCheckboxOpenModalFooterPayment: {
    key: 'amendCheckboxOpenModalFooterPayment',
    defaultValue: 'Cruise Contract and to receive balance due communications',
  },
  amendCheckboxErrorFooterPayment: {
    key: 'amendCheckboxErrorFooterPayment',
    defaultValue: 'Please acknowledge the term to continue',
  },
  bookingAmendPaymentFooterCheckboxLinkLabel: {
    key: 'bookingAmendPaymentFooterCheckboxLinkLabel',
    defaultValue: 'Cruise Ticket Contract',
  },
  amendModalContentNoticePaymentFooter: {
    key: 'amendModalContentNoticePaymentFooter',
    defaultValue:
      'IMPORTANT NOTICE TO GUESTS: Your cruise ticket contract or booking conditions, and the terms and conditions for the purchase of any products, services, shore excursions, or other activities related to your cruise, contain important limitations on the rights of passengers, including provisions relating to limitation of liability, forum selection, governing law, and the use of alternative dispute resolution to resolve certain types of disputes. To find the applicable cruise ticket contract or booking conditions, and the purchase terms and conditions, please visit ',
  },
  amendModalContentHAPaymentFooter: {
    key: 'amendModalContentHAPaymentFooter',
    defaultValue: 'HEALTH ACKNOWLEDGMENT',
  },
  amendModalContentHATextPaymentFooter: {
    key: 'amendModalContentHATextPaymentFooter',
    defaultValue:
      'To ensure your booking is not inadvertently cancelled, we may need to contact you or others in your traveling party.  By proceeding, you - on your own behalf and on behalf of all others you represent - agree to receive communications from us, at any time we deem appropriate, about any outstanding balance(s) or amount(s) due. This includes communications regarding the collection of any past due amounts even after your sailing.',
  },
  amendModalContentHAHerePaymentFooter: {
    key: 'amendModalContentHAHerePaymentFooter',
    defaultValue: 'here',
  },
  amendModalContentHATextFinalPaymentFooter: {
    key: 'amendModalContentHATextFinalPaymentFooter',
    defaultValue:
      '. A separate health acknowledgment applies to shore excursions and is available at ',
  },
  formBookingAmendFieldReservationNumberLabel: {
    key: 'formBookingAmendFieldReservationNumberLabel',
    defaultValue: 'Reservation number',
  },
  formBookingAmendFieldReservationNumber: {
    key: 'formBookingAmendFieldReservationNumber',
    defaultValue: 'Enter reservation number',
  },
  formBookingAmendFieldLastNameLabel: {
    key: 'formBookingAmendFieldLastNameLabel',
    defaultValue: 'Last name',
  },
  formBookingAmendFieldLastName: {
    key: 'formBookingAmendFieldLastName',
    defaultValue: 'Enter last name',
  },
  formBookingAmendFieldShipLabel: {
    key: 'formBookingAmendFieldShipLabel',
    defaultValue: 'Ship name',
  },
  formBookingAmendFieldShip: {
    key: 'formBookingAmendFieldShip',
    defaultValue: 'Select your ship',
  },
  amendLookUpFieldSailingDateLabel: {
    key: 'amendLookUpFieldSailingDateLabel',
    defaultValue: 'Sailing date',
  },
  amendLookUpFieldYearLabel: {
    key: 'amendLookUpFieldYearLabel',
    defaultValue: 'Year',
  },
  amendLookUpFieldMonthLabel: {
    key: 'amendLookUpFieldMonthLabel',
    defaultValue: 'Month',
  },
  amendLookUpFieldDayLabel: {
    key: 'amendLookUpFieldDayLabel',
    defaultValue: 'Day',
  },
  formBookingAmendButtonSubmit: {
    key: 'formBookingAmendButtonSubmit',
    defaultValue: 'Look up my reservation',
  },
  amendHeaderBackReservationCompleteLabel: {
    key: 'amendHeaderBackReservationCompleteLabel',
    defaultValue: 'Back to your cruise reservation',
  },
  amendHeaderReservationLabel: {
    key: 'amendHeaderReservationLabel',
    defaultValue: 'Reservation',
  },
  amendDashboardNotificationNoBookingLinkedTitle: {
    key: 'amendDashboardNotificationNoBookingLinkedTitle',
    defaultValue: 'This reservation is not associated with your account',
  },
  amendDashboardNotificationNoBookingLinkedDescription: {
    key: 'amendDashboardNotificationNoBookingLinkedDescription',
    defaultValue: 'Link reservation',
  },
  amendRetrievePageLoaderMessage: {
    key: 'amendRetrievePageLoaderMessage',
    defaultValue: 'Looking for your reservations',
  },
  paymentNotificationSuccessTitleAffirm: {
    key: 'paymentNotificationSuccessTitleAffirm',
    defaultValue: 'Payment success',
  },
  paymentNotificationSuccessTitleFullPaidWithAffirm: {
    key: 'paymentNotificationSuccessTitleFullPaidWithAffirm',
    defaultValue: 'Your booking has been paid in full with',
  },
  successFlightCancellationMessage: {
    key: 'successFlightCancellationMessage',
    defaultValue: 'Your Flights have been canceled successfully',
  },
  successFlightCancellationText: {
    key: 'successFlightCancellationText',
    defaultValue: 'To review the applied changes, go to the Flight section',
  },
  bookAdditionalFlightButtonText: {
    key: 'bookAdditionalFlightButtonText',
    defaultValue: 'Book additional flights',
  },
  manageFlightButtonText: {
    key: 'manageFlightButtonText',
    defaultValue: 'Manage flights',
  },
  loaderDashboardRedirect: {
    key: 'loaderDashboardRedirect',
    defaultValue: 'Taking you to your cruise reservation page',
  },
  loaderPaymentRedirect: {
    key: 'loaderPaymentRedirect',
    defaultValue: 'Taking you to our secure payment page',
  },
  formBookingAmendGuestSubmitTravelProtectionErrorDescription: {
    key: 'formBookingAmendGuestSubmitTravelProtectionErrorDescription',
    defaultValue:
      'Due to the recent changes, the Royal Caribbean Travel Protection Insurance has been removed from the booking.',
  },
  formBookingAmendGuestSubmitTravelProtectionErrorTitle: {
    key: 'formBookingAmendGuestSubmitTravelProtectionErrorTitle',
    defaultValue: 'IMPORTANT',
  },
};

export default Dictionary;
